import { window } from "@swa-ui/browser/window";
import { getItem, setItem } from "@swa-ui/persistence/persistence";

const CAR_PERSISTENCE_BOOKING_DATA_KEY = "carBookingDataStorage";
const CAR_PERSISTENCE_PRODUCT_DATA_KEY = "carBookingProductStorage";
const CAR_PERSISTENCE_SMARTBLOCK_STATE_KEY = "carSmartblockStateStorage";
const CAR_PERSISTENCE_TIME_TO_LIVE_IN_MINUTES = 30;

const getPersistedSmartblockStateData = () => {
  const smartblockState = getItem(CAR_PERSISTENCE_SMARTBLOCK_STATE_KEY);

  return smartblockState?.value;
};

const setPersistedSmartblockStateData = (smartblockData) => {
  setItem(CAR_PERSISTENCE_SMARTBLOCK_STATE_KEY, smartblockData, {
    timeToLiveInMinutes: CAR_PERSISTENCE_TIME_TO_LIVE_IN_MINUTES,
  });
};

const resetPersistedSmartblockStateData = () => {
  window.sessionStorage.removeItem(CAR_PERSISTENCE_SMARTBLOCK_STATE_KEY);
};

const getPersistedCarBookingData = () => {
  const carPersistenceData = getItem(CAR_PERSISTENCE_BOOKING_DATA_KEY);

  return carPersistenceData?.value;
};

const setPersistedCarBookingData = (carBookingData) => {
  setItem(CAR_PERSISTENCE_BOOKING_DATA_KEY, carBookingData, {
    timeToLiveInMinutes: CAR_PERSISTENCE_TIME_TO_LIVE_IN_MINUTES,
  });
};

const resetPersistedCarBookingData = () => {
  window.sessionStorage.removeItem(CAR_PERSISTENCE_BOOKING_DATA_KEY);
};

const getPersistedCarProductData = () => {
  const carProductData = getItem(CAR_PERSISTENCE_PRODUCT_DATA_KEY);

  return carProductData?.value;
};

const setPersistedCarProductData = (carProductData) => {
  setItem(CAR_PERSISTENCE_PRODUCT_DATA_KEY, carProductData, {
    timeToLiveInMinutes: CAR_PERSISTENCE_TIME_TO_LIVE_IN_MINUTES,
  });
};

const resetPersistedCarProductData = () => {
  window.sessionStorage.removeItem(CAR_PERSISTENCE_PRODUCT_DATA_KEY);
};

const resetAllPersistedCarData = () => {
  resetPersistedCarBookingData();
  resetPersistedCarProductData();
  resetPersistedSmartblockStateData();
};

export {
  getPersistedSmartblockStateData,
  setPersistedSmartblockStateData,
  resetPersistedSmartblockStateData,
  getPersistedCarBookingData,
  setPersistedCarBookingData,
  getPersistedCarProductData,
  resetAllPersistedCarData,
  resetPersistedCarBookingData,
  setPersistedCarProductData,
  resetPersistedCarProductData,
};
